import type { BrandMeta } from "../types";

export const meta: BrandMeta = {
    id: "basebuddy",
    name: "Base Buddy",
    title: "Base Buddy: Your Digital Companion on Base",
    description: "Everything on base, one question away.",
    themeColor: "#4a7aff",
    fontsHref:
        "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,500&display=swap",
    icons: {
        appleTouch: "bb-logo-icon.svg",
        pwaAny: "bb-logo-icon.svg",
        pwaMaskable: "bb-logo-icon-maskable.svg"
    }
};
